import React, { memo } from "react";

import { ShowcaseIntro } from "ui/components/Showcase";

import { CONTACT_WIZARD_DEFAULT_STEP, CONTACT_WIZARD_EDIT_TEXT, CONTACT_WIZARD_INTRO_TEXTS } from "./consts";
import AddressScene from "./scenes/AddressScene";
import EmailScene from "./scenes/EmailScene";
import InfoScene from "./scenes/InfoScene";
import NotesScene from "./scenes/NotesScene";
import PhoneScene from "./scenes/PhoneScene";
import PicturesScene from "./scenes/PicturesScene";
import RepresentativesScene from "./scenes/RepresentativesScene";
import SummaryScene from "./scenes/SummaryScene";
import { ContactWizardIntroProps, ContactWizardSceneProps } from "./types";

/** Scena za svaki korak čarobnjaka, po nazivu koraka. */
const STEP_SCENES: Record<string, React.FC<ContactWizardSceneProps>> = {
  Detalji: InfoScene,
  Osobe: RepresentativesScene,
  Email: EmailScene,
  Telefon: PhoneScene,
  Adrese: AddressScene,
  Bilješke: NotesScene,
  Slike: PicturesScene,
  Pregled: SummaryScene,
};

/**
 * Lijevi panel čarobnjaka kontakta: za svaki korak vlastita scena s karticama, a ispod
 * objašnjenje koraka. Ide po nazivu koraka, jer korak "Osobe" postoji samo kod tvrtke.
 */
const ContactWizardIntro: React.FC<ContactWizardIntroProps> = ({ formValues, stepCurrent, stepLabels, isEdit }) => {
  const stepLabel = stepLabels[stepCurrent];
  const currentLabel = stepLabel && STEP_SCENES[stepLabel] ? stepLabel : CONTACT_WIZARD_DEFAULT_STEP;
  const Scene = STEP_SCENES[currentLabel];
  const text =
    isEdit && currentLabel === CONTACT_WIZARD_DEFAULT_STEP ? CONTACT_WIZARD_EDIT_TEXT : CONTACT_WIZARD_INTRO_TEXTS[currentLabel];

  return (
    <ShowcaseIntro
      sceneKey={currentLabel}
      title={text.title}
      description={text.description}
      stepCurrent={stepCurrent}
      stepCount={stepLabels.length}
    >
      <Scene formValues={formValues} />
    </ShowcaseIntro>
  );
};

export default memo(ContactWizardIntro);
